import { useState, useEffect, useContext } from 'react';
import { Spinner } from '@teo/components';
import { Plus } from '@teo/components/icons';
import { axios } from '@/axios';
import { config } from '@/config';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@/components/Contexts/AuthContext';

export const AITags = ({ tags, setTags, loading, setSelectTags }) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);

  const handleAddTag = (newTag) => {
    if (newTag) {
      const promises = [];
      promises.push(
        axios.post(`${config.backend}/tags`, {
          tag: newTag,
          label: newTag,
          key: Math.floor(Math.random() * 9999999999999),
          organisationId: auth?.user?.activeOrganisationId,
          lang: auth?.user?.lang,
        })
      );
      Promise.allSettled(promises).then((results) => {
        setSelectTags((prev) => [
          ...prev,
          {
            key: newTag,
            label: newTag,
            tag: newTag,
            id: results[0].value?.data?.id,
          },
        ]);
      });
      setTags((prev) => prev.filter((tag) => tag !== newTag));
    }
  };
  return (
    <div className="flex flex-col gap-1">
      <div className="mt-3 flex items-center gap-2 text-sm text-grey-08">
        <img
          src="/images/icons/chatgpt.svg"
          alt="chatgpt"
          className="mr-2 w-5"
        />
        {t('chat_gpt.ia_tags')}
      </div>
      <div className="mt-2">
        {loading ? (
          <div className="mt-2 flex">
            <Spinner
              ariaLabel="Loading spinner"
              className="mx-auto !h-6 !w-6 border-grey-08"
            />
          </div>
        ) : (
          <div className="flex flex-wrap gap-2">
            {tags?.slice(0, 5).map((tag, i) => (
              <div
                className="flex cursor-pointer items-center gap-1 rounded-[4px] border px-2 py-1 text-xs font-medium hover:bg-grey-01"
                key={i}
                onClick={() => handleAddTag(tag)}
              >
                <Plus className="w-4 text-grey-06" />
                {tag}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
